export enum InputType {
  Custom,
  Text,
  Area,
  Filled,
  IpInput,
  Switch,
  Table,
  Select,
  MultipleSelect,
  MultipleInput,
  MultipleSelectInput,
  Action,
  Checkbox,
  Radio,
  Password,
}

export enum Direction {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Buttom = 'bottom',
  Outside = 'outside',
}

export enum InputMod {
  Filled,
  Default,
  Clean,
}

export enum VariantType {
  Contained,
  Outlined,
  Transparent,
  Icon,
  Clean,
  Normal,
  Custom,
}

export enum columnSpace {
  Half,
  TwoOverFive,
  ThreeOverFive,
}

export enum columnDirection {
  Row,
  Column,
  ColumnRow,
}

export enum InputTextType {
  Normal,
  Uppercase,
  Capitalize,
}
